import { render, staticRenderFns } from "./ExperiencesDetails.vue?vue&type=template&id=0b8be134&scoped=true&"
import script from "./ExperiencesDetails.vue?vue&type=script&lang=js&"
export * from "./ExperiencesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperiencesDetails.vue?vue&type=style&index=0&id=0b8be134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8be134",
  null
  
)

export default component.exports